import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import HomePage from './pages/HomePage';
import GuidesIndexPage from './pages/GuidesIndexPage';
import GuideArticlePage from './pages/GuideArticlePage';
import NotFoundPage from './pages/NotFoundPage';
import { homeRedirectTarget } from './utils/lastTab';
import { Box, CircularProgress } from '@mui/material';

// The editor is self-contained, so keep it out of the converter's bundle.
const TextEditorPage = lazy(() => import('./pages/TextEditorPage'));
const TypingTestPage = lazy(() => import('./pages/TypingTestPage'));

const PageFallback = (
  <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
    <CircularProgress />
  </Box>
);

/** Home page, or — on a fresh visit — the tool the user used last. */
const HomeRoute: React.FC = () => {
  const target = homeRedirectTarget(useLocation());
  return target ? <Navigate to={target} replace /> : <HomePage />;
};

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<HomeRoute />} />
          <Route path="/guides" element={<GuidesIndexPage />} />
          <Route path="/guides/:slug" element={<GuideArticlePage />} />
          <Route
            path="/text-editor"
            element={
              <Suspense fallback={PageFallback}>
                <TextEditorPage />
              </Suspense>
            }
          />
          <Route
            path="/typing-test"
            element={
              <Suspense fallback={PageFallback}>
                <TypingTestPage />
              </Suspense>
            }
          />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
